import * as React from 'react';


import { Button, Container, Row, Col, Form } from 'react-bootstrap';
import { View, Text, rem, IconButton, Touchable } from '../libs/WebComponents';
import {useUserStore} from '../store/user';
import { HandleFetchError } from '../api/api-root';
import Animatable from './Animatable';
import { wpAuthPOST } from '../api/api-user';


const OptinBox = (props: {optin: boolean, onChange: (c: boolean)=>void}) => {
   return <Touchable className={`optin-box ${props.optin?'checked':''}`} onPress={()=>props.onChange(!props.optin)}>
         <IconButton name={props.optin?'Check':'Minus'} size={rem(4)} iconColor={props.optin?'var(--color-white)':'var(--color-gray-light)'} color={props.optin?'var(--color-green)':'var(--color-gray)'}/>
      </Touchable>
};


const EmailForm = () => {

   const {token, group_id, removeUser} = useUserStore();
   const [errorEmail, setErrorEmail] = React.useState(false);
   const [loading, setLoading] = React.useState(false);
   const [isSuccess, setIsSuccess] = React.useState(false);
   const [optin, setOptin] = React.useState<null | boolean>();

   React.useEffect(()=>{
      setTimeout(()=>setOptin(false),1000);
   },[]);

   const submitEmailForm = async(e: any)=>{
      e.preventDefault();
      const email: string = String(e.target.email.value);
      const valid_email = email.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/);
      setErrorEmail(!valid_email);
      if (valid_email && optin)
      {
         setLoading(true);
         try{
            const results: any | {success: boolean} = await wpAuthPOST('user/optin', {group_id, email});
            if (results && results.success)
            {
               setIsSuccess(true);
               removeUser();
            }
         }catch(err: HandleFetchError | any)
         {
            console.warn(err.error);
         }finally{
            setLoading(false);
         }
      }
   };

   return (
      <Form onSubmit={submitEmailForm} name="email-form" style={{paddingBottom:rem(5)}}>
         {!token && !isSuccess?<View style={{flex:1,justifyContent:'center',alignItems:'center',paddingTop:'15vh'}}>
            <Text>Oeps, iets gaat hier mis 🫤</Text>
         </View>:!isSuccess?(
         <Container>
            <Row className='justify-content-center' style={{marginBottom:rem(5)}}>
               <Col className="col-12 col-md-8 col-lg-6 d-flex align-items-center" style={{lineHeight:'1.1em'}}>
                  <Text style={{marginLeft:'auto',fontWeight:'bold',textAlign:'center',userSelect:'none'}}>Liever niet</Text>
                  <OptinBox onChange={(c: boolean)=>setOptin(c)} optin={optin !==false?true:false}/>
                  <Text style={{marginRight:'auto',fontWeight:'bold',textAlign:'center',userSelect:'none'}}>Da's OK!</Text>
               </Col>
            </Row>
            <Row style={{opacity:optin?1:.4}} className="justify-content-center align-items-end">
               <Col className="col-12 col-md-8 col-md-6 col-lg-4 text-md-left">
                  <Form.Group className={`mb-4 ${errorEmail?'is-invalid':''}`}>
                     <Form.Label className="mx-4">Jouw e-mailadres</Form.Label>
                     <Form.Control name="email" type="email" style={{backgroundColor:'var(--color-white)'}} placeholder="Schrijf jouw e-mailadres" disabled={!optin} />
                  </Form.Group>
               </Col>
               <Col className="col-12 col-md-3 col-lg-2 text-xs-center text-sm-center text-md-left">
                  <Form.Group className="mb-4">
                     <Button variant="success" type="submit" disabled={loading || !optin} style={{minWidth:rem(20)}}>
                        {loading?'Verwerken':'Verzend'}
                     </Button>
                  </Form.Group>
               </Col>
            </Row>
         </Container>):(
         <Animatable.View animation={'flash'} duration={1000}><Text h2 style={{color:'var(--color-green)',textAlign:'center'}}>Succesvol verzonden!</Text></Animatable.View>
         )}
      </Form>
   );
}

export default React.memo(EmailForm);

